import React, { useState } from "react";

export default function MfgInsuranceForm() {
  const [agree, setAgree] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    manufacturerName: "",
    factorySize: "",
    location: "",
    machineryType: "",
    coverageType: "",
    insuranceAmount: "",
    premiumBudget: "",
    duration: "",
    remarks: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!agree) {
      alert("⚠️ You must agree to the Terms & Conditions before submitting.");
      return;
    }
    // console.log("Manufacturing Insurance Lead Submitted:", formData);
    alert("✅ Insurance request submitted! Our Mfg Insurance Partner will contact you.");
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50 p-6">
      <form
        onSubmit={handleSubmit}
        className="bg-gray-700 shadow-lg rounded-2xl p-6 w-full max-w-lg border border-gray-500"
      >
        <h2 className="text-2xl font-bold text-center text-yellow-200 mb-6">
          🏭 Mfg Insurance: Protecting Manufacturers, Securing Assets
        </h2>
        <p className="text-white text-center mb-6 text-sm">
          Register your interest for machinery or factory insurance. Our partners will provide tailored coverage options.
        </p>

        {/* Manufacturer Details */}
        <label className="block mb-2 font-medium">Manufacturer / Company Name</label>
        <input
          type="text"
          name="manufacturerName"
          value={formData.manufacturerName}
          onChange={handleChange}
          className="w-full p-2 mb-4 border rounded-lg"
          placeholder="Enter manufacturer or company name"
        />

        <label className="block mb-2 font-medium">Factory / Facility Size (in sq.ft.)</label>
        <input
          type="number"
          name="factorySize"
          value={formData.factorySize}
          onChange={handleChange}
          className="w-full p-2 mb-4 border rounded-lg"
          placeholder="e.g., 5000"
        />

        <label className="block mb-2 font-medium">Factory Location</label>
        <input
          type="text"
          name="location"
          value={formData.location}
          onChange={handleChange}
          className="w-full p-2 mb-4 border rounded-lg"
          placeholder="City, State"
        />

        <label className="block mb-2 font-medium">Machinery / Equipment Type</label>
        <input
          type="text"
          name="machineryType"
          value={formData.machineryType}
          onChange={handleChange}
          className="w-full p-2 mb-4 border rounded-lg"
          placeholder="Lathe, CNC, Conveyor, etc."
        />

        {/* Insurance Details */}
        <label className="block mb-2 font-medium">Coverage Type</label>
        <select
          name="coverageType"
          value={formData.coverageType}
          onChange={handleChange}
          className="h-10 p-2 mb-4 border rounded-lg w-full"
        >
          <option value="">-- Select Coverage --</option>
          <option value="Machinery Damage">Machinery Damage</option>
          <option value="Fire & Theft">Fire & Theft</option>
          <option value="Natural Disaster">Natural Disaster</option>
          <option value="Multi-Peril">Multi-Peril Insurance</option>
        </select>

        <label className="block mb-2 font-medium">Insurance Amount (₹)</label>
        <input
          type="number"
          name="insuranceAmount"
          value={formData.insuranceAmount}
          onChange={handleChange}
          className="w-full p-2 mb-4 border rounded-lg"
          placeholder="e.g., 500000"
        />

        <label className="block mb-2 font-medium">Premium Budget (₹)</label>
        <input
          type="number"
          name="premiumBudget"
          value={formData.premiumBudget}
          onChange={handleChange}
          className="w-full p-2 mb-4 border rounded-lg"
          placeholder="e.g., 20000 per year"
        />

        <label className="block mb-2 font-medium">Coverage Duration</label>
        <select
          name="duration"
          value={formData.duration}
          onChange={handleChange}
          className="h-10 w-full p-2 mb-4 border rounded-lg"
        >
          <option value="">-- Select Duration --</option>
          <option value="6 Months">6 Months</option>
          <option value="12 Months">12 Months</option>
          <option value="24 Months">24 Months</option>
        </select>

        {/* Remarks */}
        <label className="block mb-2 font-medium">Additional Remarks</label>
        <textarea
          name="remarks"
          value={formData.remarks}
          onChange={handleChange}
          style={{ height: "120px" }}
          className="w-full p-2 mb-4 border rounded-lg text-sm"
          placeholder="Any special request or info..."
        />

        {/* Terms & Conditions */}
        <div className="flex items-center mb-4 text-sm text-gray-600">
          <input
            type="checkbox"
            checked={agree}
            onChange={(e) => setAgree(e.target.checked)}
            className="mr-2"
          />
          <button
            type="button"
            onClick={() => setShowModal(true)}
            className="text-blue-600 underline"
          >
            I agree to the Terms & Conditions
          </button>
        </div>

        {/* Submit */}
        <button
          type="submit"
          className="w-full bg-yellow-500 hover:bg-yellow-600 text-black py-2 rounded-lg"
        >
          Submit Insurance Request
        </button>
      </form>

      {/* Terms Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="bg-gray-700 rounded-2xl shadow-lg w-11/12 max-w-2xl p-6 overflow-y-auto max-h-[80vh]">
            <h2 className="text-xl font-bold mb-4 text-center text-yellow-200">
              🏭 Mfg Insurance Terms & Conditions
            </h2>
            <div className="text-sm text-white space-y-3">
              <p>1. Insurance is provided by registered insurance companies under SyntraMfg.</p>
              <p>2. Applicants must provide valid KYC and factory/machinery ownership documents.</p>
              <p>3. Premium payments must be made as per policy terms.</p>
              <p>4. Claims are subject to verification and insurance company rules.</p>
              <p>5. SyntraMfg acts only as a digital facilitator between manufacturers and insurers.</p>
              <p>6. Data is confidential and shared only with authorized partners.</p>
              <p>7. Disputes fall under Indian jurisdiction (Mumbai courts).</p>
            </div>
            <div className="mt-6 flex justify-center">
              <button
                onClick={() => setShowModal(false)}
                className="bg-yellow-500 hover:bg-yellow-600 text-black px-4 py-2 rounded-lg"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
